import Button from 'components/Button'
import { useFormikContext } from 'formik'
import React from 'react'
import { _ } from 'utils'

const SubmitButton = ({
    text = _('button.save'),
    className
}: { text?: string, className?: string }) => {
    const { handleSubmit } = useFormikContext()
    return (
        <Button
            className={className}
            variant="success"
            style={{ margin: '0 10px' }}
            onClick={handleSubmit}
        >
            {text}
        </Button>
    )
}

export default SubmitButton
